<template>
    <div class="dropdown-divider" />
</template>

<script>
export default {

    name: 'DropdownMenuDivider'

};
</script>
